import type { InsightSeverity } from '../api/insights';

/** Mirrors the `tone` union accepted by the design-system `Badge`. */
export type BadgeTone = 'neutral' | 'success' | 'warning' | 'destructive' | 'info';

export const SEVERITY_TONE: Record<InsightSeverity, BadgeTone> = {
  critical: 'destructive',
  warning: 'warning',
  info: 'info',
};

export const SEVERITY_LABEL: Record<InsightSeverity, string> = {
  critical: 'Critical',
  warning: 'Warning',
  info: 'Info',
};

/** Triage order: the worst thing must be read first. */
const SEVERITY_RANK: Record<InsightSeverity, number> = {
  critical: 0,
  warning: 1,
  info: 2,
};

/**
 * Sorts by severity, then newest first. The insights API returns rows in
 * generation order, which is not the order an operator needs to read them in.
 */
export const byTriageOrder = (a: { severity: InsightSeverity; computedAt: string }, b: {
  severity: InsightSeverity;
  computedAt: string;
}): number => {
  const bySeverity = SEVERITY_RANK[a.severity] - SEVERITY_RANK[b.severity];
  if (bySeverity !== 0) return bySeverity;
  return new Date(b.computedAt).getTime() - new Date(a.computedAt).getTime();
};
